module.exports = __webpack_public_path__ + "img/bmh.e3c98c9f.png";